/**
 *  ・クラス名
 *    ポータルモデル
 *  ・概要
 *    ポータル画面構成に関連に必要な処理を記述
 *  ・更新履歴
 *    2021/02/19 新規作成 佐藤
 *    2021/03/01 更新 佐藤 アイテムの閲覧は権限（ロール）の付与状況により変更されるためフロントでは特に考えない
 */
import BaseModel from './baseModel';
// import Employee from '@/models/data/employee';

export default class PortalModel extends BaseModel {
  // private employee = new Employee;

  /* eslint-disable @typescript-eslint/camelcase */
  private localPayload = {
    conditions: [] as Array<{[key: string]: string | string[]}>,
    per_page: 0,
    page: 1,
    use_display_id: true,
    return_count_only: true, // 件数のみ取得する
    omit_fields_data: true
  };

  constructor() {
    super();
  }

  /**
   * 社員マスタを取得します
   * @returns {object}
   */
  public async getMasterData() {
    // return await this.employee.getFormatData();
  }

  /**
   * ワークフローに表示するアイテムを取得します
   * @param {string} appId 
   * @param {string} datastoreId - データストアID
   * @param {string} statusId - 検索対象となるステータスID
   */
  async getCountByStatus(appId:string, datastoreId: string, statusId: string) {
    this.localPayload.conditions.splice(0);
    this.localPayload.conditions.push({
      "id": "status",
      "search_value": [statusId]
    });
    return this.getItemCount(appId, datastoreId, this.localPayload);
  }
}
